import {LocalisedTypography} from "@components/localisation/LocalisedTypography";
import {EmailPassword} from "@components/authentication/EmailPassword";
import {Dialog} from "@components/interface/Dialog";
import {Game} from "@game/game";
import {IDialog, update as updateDialog} from "@redux/slices/dialog";
import {selectDialog} from "@redux/selectors/dialog";
import {connect} from "react-redux";
import React, {CSSProperties} from "react";
import {Update} from "@redux/slices/base";

const styles: Record<string, CSSProperties> = {
    bottomBar: {
        display: "flex",
        justifyContent: "flex-end",
        marginTop: 8
    },
    button: {
        fontSize: "large",
        margin: 2,
        padding: 4
    }
};

interface ILogin {
    dialog: IDialog
    game: Game
    updateDialog: Update
}
function AuthenticateDialog({dialog, game, updateDialog}: ILogin) {
    const handleCloseClick = () => {
        updateDialog({update: {}})
    };

    if (dialog.name !== "authenticate" && (game?.userPlayer || game.anonymousLoginPermitted)) {
        return null;
    }
    return (
        <Dialog title="TitleWordland">
            <LocalisedTypography content="AuthenticationRequired"/>
            <h3>
                <LocalisedTypography content="AuthenticationEmailPassword"/>
            </h3>
            <EmailPassword onSuccess={() => updateDialog({update: dialog.data?.return ?? {name: "scores"}})}/>
            <div style={styles.bottomBar}>
                {game.anonymousLoginPermitted && <button onClick={handleCloseClick} style={styles.button}>
                    <LocalisedTypography content="ButtonClose"/>
                </button>}
            </div>
        </Dialog>
    );
}

const mapStateToProps = (store: never) => ({
    dialog: selectDialog(store)
});
const connected = connect(mapStateToProps, {
    updateDialog
})(AuthenticateDialog);
export {connected as AuthenticateDialog}
